import { render, staticRenderFns } from "./BmvDialog.vue?vue&type=template&id=3c9c71e0&scoped=true"
import script from "./BmvDialog.vue?vue&type=script&lang=js"
export * from "./BmvDialog.vue?vue&type=script&lang=js"
import style0 from "./BmvDialog.vue?vue&type=style&index=0&id=3c9c71e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9c71e0",
  null
  
)

export default component.exports